import { BorderBottom } from '@mui/icons-material';
import React from 'react';

export default function DashboardCardHeader(props) {
    return(
        <div className="dashCardHeaderTitle" style={{...props, borderBottom: (props.borderBottom === 'true') ? '1px solid #EBEDF5' : 'unset' }}>
            {props.title}
        </div>
    )
}

